
import React, { useState } from 'react';
import DQResultModal from './DQResultModal';

const DataQualityInfo = ({ dqInfo, productId, assetName, dqStatus, dqResults, hideResults = false }) => {

  console.log("dq status", dqStatus)
  console.log("dq results", dqResults)
  const [showResultModal, setShowResultModal] = useState(false);

  if (!dqInfo) {
    return <div className="text-gray-600">No data quality information available.</div>;
  }

  const { AssetLevelRules, ColumnLevelRules, Weightage } = dqInfo;

  // Get asset ID from rules
  const assetId = AssetLevelRules?.[0]?.data_asset_id || ColumnLevelRules?.[0]?.data_asset_id;

  // Use the assetName prop directly instead of extracting from rules
  // const assetName = AssetLevelRules?.[0]?.rule_name?.split('|')?.[1] || 
  //                  ColumnLevelRules?.[0]?.rule_name?.split('|')?.[1] || 'Unknown Asset';

  // Combine all rules into a single array for the table
  const allRules = [];
  
  if (AssetLevelRules && Array.isArray(AssetLevelRules)) {
    AssetLevelRules.forEach(rule => {
      if (rule) {
        allRules.push({
          ruleType: 'Asset',
          ruleName: rule?.rule_name || 'N/A',
          description: rule?.rule_description || 'N/A',
          dimension: rule?.dimension_name || 'N/A',
          checkName: rule?.check_name || 'N/A',
          attributeUsed: rule?.attributes || 'N/A'
        });
      }
    });
  }
  
  if (ColumnLevelRules && Array.isArray(ColumnLevelRules)) {
    ColumnLevelRules.forEach(rule => {
      if (rule) {
        allRules.push({
          ruleType: 'Column',
          ruleName: rule?.rule_name || 'N/A',
          description: rule?.rule_description || 'N/A',
          dimension: rule?.dimension_name || 'N/A',
          checkName: rule?.check_name || 'N/A',
          attributeUsed: rule?.attributes || 'N/A'
        });
      }
    });
  }

  const handleViewResult = () => {
    if (dqResults) {
      setShowResultModal(true);
    }
  };

  // Function to get result display for a specific rule
  const getResultDisplay = (rule) => {
    if (dqResults && dqResults.rules) {
      // Find the matching rule in dqResults
      const matchingRule = dqResults.rules.find(dqRule => 
        dqRule.rule_name === rule.ruleName || 
        dqRule.rule_description === rule.description
      );

      if (dqStatus === 'Success') {
        if (matchingRule) {
          if (matchingRule.dq_result === 'pass') {
            return (
              <button 
                className="text-blue-600 hover:text-blue-800 font-medium cursor-pointer"
                onClick={handleViewResult}
              >
                View Result
              </button>
            );
          } else if (matchingRule.dq_result === 'fail') {
            return <span className="text-red-600 font-medium">Failed</span>;
          } else {
            return <span className="text-gray-500 font-medium">Unknown</span>;
          }
        }
      } else if (dqStatus === 'Failed') {
        return <span className="text-red-600 font-medium">Failed</span>;
      } else if (dqStatus === 'Pending') {
        return <span className="text-gray-500 font-medium">Pending</span>;
      }
      else if (dqStatus === 'Unknown') {
        return <span className="text-gray-500 font-medium">Unknown</span>;
      } else {
        return <span className="text-gray-400 font-medium">Failed</span>;
      }
      
     
    }
    
    // Fallback to overall status if no matching rule found
   
  };

  return (
    <div className="space-y-6">
      {/* DQ Status Check Section */}
      {/* <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <div className="flex items-center justify-between">
          <div>
            <h4 className="text-base font-semibold text-blue-800 mb-2">Data Quality Status</h4>
            <p className="text-sm text-blue-600">
              Check the current status of data quality rules for this asset
            </p>
          </div>
          <div className="text-right">
            <div className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${
              dqStatus === 'Success' ? 'bg-green-100 text-green-800' :
              dqStatus === 'Failed' ? 'bg-red-100 text-red-800' :
              dqStatus === 'Error' ? 'bg-gray-100 text-gray-800' :
              'bg-yellow-100 text-yellow-800'
            }`}>
              {dqStatus}
            </div>
          </div>
        </div>
      </div> */}

      {/* Data Quality Rules Table */}
      <div className="bg-white rounded-lg shadow-sm border border-blue-200 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full">
            <thead className="bg-[#0000a0]">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Rule Type</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Rule Name</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Description</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Dimension</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Check Name</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Attribute Used</th>
                {!hideResults && (
                  <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Results</th>
                )}
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-blue-200">
              {allRules.length > 0 ? (
                allRules.map((rule, idx) => (
                  <tr key={idx} className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {rule?.ruleType || 'N/A'}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-700">
                      {rule?.ruleName || 'N/A'}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-700 max-w-xs truncate" title={rule?.description}>
                      {rule?.description || 'N/A'}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-700">
                      {rule?.dimension || 'N/A'}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-700">
                      {rule?.checkName || 'N/A'}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-700 max-w-xs truncate" title={rule?.attributeUsed}>
                      {rule?.attributeUsed || 'N/A'}
                    </td>
                    {!hideResults && (
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                        {getResultDisplay(rule)}
                      </td>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={hideResults ? "6" : "7"} className="px-6 py-4 text-center text-sm text-gray-500">
                    No data quality rules available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Weightage Section */}
      {Weightage && Object.keys(Weightage).length > 0 && (
        <div>
          <h4 className="font-semibold text-lg mb-3 text-gray-900">Weightage</h4>
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white rounded-lg overflow-hidden shadow-sm">
              <thead className="bg-[#0000a0]">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Dimension</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Weightage (%)</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {Object.entries(Weightage).map(([dimension, weightage]) => (
                  <tr key={dimension} className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {dimension?.replace(/_/g, ' ')?.replace(/\b\w/g, c => c.toUpperCase()) || 'N/A'}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-700">{weightage || 0}%</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* DQ Result Modal */}
      <DQResultModal
        open={showResultModal}
        onClose={() => setShowResultModal(false)}
        assetResults={dqResults}
        assetName={assetName}
      />
    </div>
  );
};

export default DataQualityInfo; 